import { Button } from 'antd';
import Text from 'antd/lib/typography/Text';
import React, { useState, useEffect } from 'react';
import { Col, Row } from 'antd/lib/grid';
import { CloseOutlined } from '@ant-design/icons';

import AudioPlayButton from './audio-play-button';
import getLabelDisplayName from 'utils/label-display';

interface Props {
    croppedImages: any;
    audioBlobURL: string;
    states: any[];
    audio: React.MutableRefObject<HTMLAudioElement[]>;
    playAudio: (idx: number) => void;
    audiolisteners: any;
    audioPlayingIdx: number;
    frameSpeed: number;
    setAudioPlayingIdx: (idx: number) => void;
    setDoneButtonDisabled: (disabled: boolean) => void;
    onRemoveAnnotation: (state: any) => void;
}

function FaceDuplicateRemoval(props: Props) {
    const {
        states,
        audioBlobURL,
        audio,
        croppedImages,
        audiolisteners,
        audioPlayingIdx,
        frameSpeed,
        playAudio,
        setAudioPlayingIdx,
        setDoneButtonDisabled,
        onRemoveAnnotation,
    } = props;

    useEffect(() => {
        setDoneButtonDisabled(false);
    }, []);

    const [duplicatesRemoved, setDuplicatesRemoved] = useState(false);

    useEffect(() => {
        setDoneButtonDisabled(false);

        return () => setDoneButtonDisabled(true);
    }, []);

    useEffect(() => {
        if (duplicatesRemoved) {
            setDoneButtonDisabled(true);
        }
    }, [duplicatesRemoved]);

    return (
        <>
            <div style={{ padding: '0 0 24px 0', textAlign: 'center' }}>
                <Text type="secondary" style={{ fontSize: '16px' }}>
                    {!duplicatesRemoved && 'Please remove duplicates (if any). Click "Done" if there are no duplicates.'}
                    {duplicatesRemoved &&
                        'Once you are done, click "Done" to go back and verify transcript assignments.'}
                </Text>
            </div>
            <div style={{ overflowY: 'auto', maxHeight: '60vh', padding: '12px' }}>
                <Row gutter={[24, 24]} justify="center">
                    {states.map((state, idx) => (
                        state && (
                            <Col xs={24} sm={12} md={8} key={`duplicate-card-${idx}`} style={{ display: 'flex', justifyContent: 'center' }}>
                                <div style={{
                                    width: '100%',
                                    maxWidth: '240px',
                                    backgroundColor: '#fff',
                                    borderRadius: '8px',
                                    border: '1px solid #e8e8e8',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    overflow: 'hidden',
                                    position: 'relative'
                                }}>
                                    <div style={{
                                        position: 'absolute',
                                        top: '8px',
                                        right: '8px',
                                        zIndex: 10
                                    }}>
                                        <Button
                                            danger
                                            type="primary"
                                            size="small"
                                            shape="circle"
                                            icon={<CloseOutlined />}
                                            onClick={() => {
                                                onRemoveAnnotation(state);
                                                setDuplicatesRemoved(true);
                                            }}
                                            title="Remove duplicate"
                                        />
                                    </div>
                                    <div style={{ height: '180px', backgroundColor: '#fafafa', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                        {state.objectType === 'audioselection' && audioBlobURL ? (
                                            <AudioPlayButton
                                                audioBlobURL={audioBlobURL}
                                                audio={audio}
                                                audioPlayingIdx={audioPlayingIdx}
                                                frameSpeed={frameSpeed}
                                                audiolisteners={audiolisteners}
                                                idx={idx}
                                                playAudio={playAudio}
                                                setAudioPlayingIdx={setAudioPlayingIdx}
                                                state={state}
                                            />
                                        ) : state.objectType === 'shape' && croppedImages[idx] ? (
                                            <img
                                                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                                src={croppedImages[idx]}
                                                alt="Duplicate Face"
                                            />
                                        ) : (
                                            <Text type="secondary">No Image</Text>
                                        )}
                                    </div>
                                    <div style={{ padding: '12px', textAlign: 'center', borderTop: '1px solid #f0f0f0' }}>
                                        <Text strong>
                                            {getLabelDisplayName(state.label.name)}{' '}
                                            {state.attributes[
                                                state.label.attributes?.find(
                                                    (attr: any) => attr.name === 'identifier',
                                                )?.id
                                            ] || ''}
                                        </Text>
                                    </div>
                                </div>
                            </Col>
                        )
                    ))}
                </Row>
            </div>
        </>
    );
}

export default FaceDuplicateRemoval;
